import { actions } from 'app-webtech-core/actions';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { TRACK_EVENTS } from 'app-webtech-core/modules/playbackSession/actions/types';
import { SET_IS_VIDEO_REQUESTED } from './types';

const setIsVideoRequested = actionCreator(SET_IS_VIDEO_REQUESTED);
const startTrackingAction = actionCreator(TRACK_EVENTS);

export const setIsVideoRequestedAction = (payload) => (dispatch, getState) => {
  const state = getState();
  if (!state.playbackSession.trackChannelEvents) {
    dispatch(actions.guide.setPrevContentKind({ prevContentKind: null }));
    dispatch(
      startTrackingAction({
        trackChannelEvents: true,
      }),
    );
  }
  dispatch(setIsVideoRequested(payload));
};
